/**
 * 爱微圈导航 · 侧边栏 / 抽屉 / 账户 / 添加
 * 本文件是运行时源（唯一真源）—— 由 tools/split_appjs.py 从 assets/js/app.js 一次性
 * 拆分而来，此后各模块独立维护。**改前端逻辑就改这里**，改完执行 `bash build.sh`
 * 打包成 assets/js/app.min.js（index.php 自动优先引用 .min 产物）。
 * assets/js/app.js 只是拆分时的原始素材，运行时不再加载，勿改。
 */

import { applyWeather, greeting, loadDailyContent, loadWeather, renderClockGreet, renderWeatherPop, tickClock, toggleWeatherPop, weatherGeolocate } from './clock.js';
import { $, $$, API, API_TIMEOUT_MS, CACHE_KEY_LEGACY, DEFAULT_SETTINGS, apiGet, apiPost, bootData, cacheKey, debounce, esc, escAttr, fetchWithTimeout, gateGuest, randomColor, safeUrl, shouldAnimate, state, toast } from './core.js';
import { CAT_ICONS, ICO_CHECK, ICO_COPY, ICO_EDIT, ICO_EXPAND, ICO_PIN, ICO_TRASH, NOTE_COLORS, addNote, addTodo, copyNote, loadCategories, loadNotes, loadTodos, loadWebsiteIcon, loadWebsites, observeWebsiteIcons, openNoteEditor, preloadAdjacentCategories, relTime, renderCategories, renderNotes, renderTodos, renderWebsiteList, startTodoEdit, toggleTodo, websiteIconUrls } from './data.js';
import { showContextMenu, showEditModal, showFolderModal } from './edit.js';
import { BUILTIN_ACTIONS, init } from './main.js';
import { closeModal, createCloudBackup, loadBackupListInto, modalConfirm, openModal, runDataRepair, setupDataButtons, showBackupList, showModalError, showQrSync } from './modal.js';
import { ONBOARDING_STEPS, closeOnboarding, maybeShowOnboarding, nextOnbStep, renderOnbStep, showOnboarding } from './onboarding.js';
import { batchDelete, batchMoveToPage, enforcePageCapacity, getPageCapacity, goNextPage, goPrevPage, initBatchToolbar, loadShortcuts, loadShortcutsRaw, prefetchAdjacentPages, prefetchPage, renderPages, shiftPagesAfterRemoval, switchPage, toggleOrganizeMode, updateBatchToolbar, updatePageArrows } from './pages.js';
import { _readIconStore, _reduceMotion, _saveIconStore, _scFp, cardRenderFp, currentGrid, faviconOf, flipMove, getGridCols, gridRenderFp, persistGridReorder, preconnectUrl, renderCardView, renderCardViewAll, renderIcon, renderShortcuts, renderSkeleton, waitTransition } from './render.js';
import { TAB_TARGETS, bindEngineIconFallback, currentEngine, engineBadgeHtml, engineFamily, fetchSuggestions, handleSearch, hideSuggestions, openTarget, renderEngineBadge, renderEngineDropdown, showEngineAddModal } from './search.js';
import { applySettings, bindSettingsUI, loadSettings, scheduleSave } from './settings.js';
import { bindDonateCard, bindShareCard, detectPayApp, fmtDonateTime, loadDonateRank, renderDonateRank, shareQrSrc, shareTargetUrl, shareTextDesc, shareTextTitle, showAboutModal, showContactModal, showDonateModal, showFeedbackModal, showPrivacyModal, showShareModal, showTermsModal } from './share.js';
import { CACHE_TTL, CATEGORY_ENGINE_MAP, applySearchTabUI, cacheState, disableNotifications, enableNotifications, mapCategoryToEngine, notifyEnabled, restoreCache, setNotifyEnabled, showNotification, submitSiteForReview, syncEnabled, toggleSync, trackVisit } from './sync.js';
import { SWATCH_COLORS, showWallpaperModal } from './wallpaper.js';

export function openSidebar(tab) {
    $('#sidebar').classList.add('open');
    $('#sidebarOverlay').classList.add('show');
    const useTab = tab || state.lastSidebarTab || 'add';
    switchSidebarTab(useTab);
    if (useTab === 'add') {
        state.currentCat = 0;
        if (!state.categories.length) { loadCategories().then(loadWebsites).catch(() => {}); }
        else { renderCategories(); loadWebsites(); }
    }
    if (useTab === 'my') renderProfile();
    if (useTab === 'settings') bindSettingsUI();
}

export function closeSidebar() {
    $('#sidebar').classList.remove('open');
    $('#sidebarOverlay').classList.remove('show');
    cacheState();
}

export function switchSidebarTab(tab) {
    $$('.sidebar-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === tab));
    $$('.tab-panel').forEach(p => p.classList.toggle('show', p.dataset.panel === tab));
    state.lastSidebarTab = tab;
    if (tab === 'my') renderProfile();
    if (tab === 'settings') bindSettingsUI();
}

export function openDrawer(sel, loader) {
    const el = $(sel);
    el.classList.add('open');
    const ov = $('#drawerOverlay');
    if (ov) ov.classList.add('show');
    if (loader) loader();
}

export function closeDrawers() {
    $$('.drawer').forEach(d => d.classList.remove('open'));
    const ov = $('#drawerOverlay');
    if (ov) ov.classList.remove('show');
}

/* ---------- 我的面板 ---------- */

export function renderProfile() {
    const u = state.user;
    const avatar = $('#profileAvatar');
    const syncCard = $('#syncCard');
    const DEFAULT_AVATAR = '/assets/img/avatar-default.png';
    if (u) {
        if (u.avatar_url) {
            avatar.innerHTML = `<img src="${escAttr(u.avatar_url)}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:50%">`;
            avatar.style.background = 'none';
        } else {
            avatar.innerHTML = `<img src="${DEFAULT_AVATAR}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:50%">`;
            avatar.style.background = '#fff';
        }
        $('#profileName').textContent = u.is_guest ? '游客' : (u.nickname || u.email);
        $('#profileSub').textContent = u.is_guest ? (state.site.profile_login_sync || '点击登录 / 注册，同步你的数据') : u.email;
        const btnAcc = $('#btnAccount');
        btnAcc.textContent = u.is_guest ? '登录' : '管理';
        btnAcc.style.display = '';
        $('#btnLogout').style.display = u.is_guest ? 'none' : '';
        // 云同步卡片：登录用户显示
        if (syncCard) syncCard.style.display = u.is_guest ? 'none' : '';
        // 顶栏扫码同步按钮：登录后显示
        const sidebarQr = $('#btnSidebarQr');
        if (sidebarQr) sidebarQr.style.display = u.is_guest ? 'none' : '';
        // 更新同步状态
        if (!u.is_guest) {
            const toggle = $('#syncToggle');
            if (toggle) toggle.classList.toggle('on', !!u.sync_enabled);
            const lastTime = $('#syncLastTime');
            if (lastTime) lastTime.textContent = u.last_sync ? '上次同步：' + formatTime(u.last_sync) : '与其他设备保持同步';
        }
    } else {
        avatar.innerHTML = `<img src="${DEFAULT_AVATAR}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:50%">`;
        avatar.style.background = '#fff';
        $('#profileName').textContent = state.site.profile_guest || '未登录';
        $('#profileSub').textContent = state.site.profile_login_prompt || '点击登录 / 注册';
        if (syncCard) syncCard.style.display = 'none';
        const sidebarQr2 = $('#btnSidebarQr');
        if (sidebarQr2) sidebarQr2.style.display = 'none';
    }
}


export function formatTime(ts) {
    if (!ts) return '';
    const d = new Date(ts.replace ? ts.replace(' ', 'T') : ts);
    if (isNaN(d.getTime())) return ts;
    const now = new Date();
    const diff = (now - d) / 1000;
    if (diff < 60) return '刚刚';
    if (diff < 3600) return Math.floor(diff / 60) + '分钟前';
    if (diff < 86400) return Math.floor(diff / 3600) + '小时前';
    return d.getMonth() + 1 + '月' + d.getDate() + '日';
}

export function showAuthModal(mode = 'login', prefillEmail = '') {
    mode = mode === 'register' ? 'register' : 'login';
    const site = state.site || {};
    const emailEnabled = site.login_email_enabled !== '0'; // 默认开启
    const socials = [
        { key: 'qq',     label: 'QQ 登录',     enabled: site.login_qq_enabled === '1',
          svg: '<svg viewBox="0 0 24 24" fill="#1EBAFC"><path d="M21.395 15.035a40 40 0 0 0-.803-2.264l-1.079-2.695c.001-.032.014-.562.014-.836C19.526 4.632 17.351 0 12 0S4.474 4.632 4.474 9.241c0 .274.013.804.014.836l-1.08 2.695a39 39 0 0 0-.802 2.264c-1.021 3.283-.69 4.643-.438 4.673.54.065 2.103-2.472 2.103-2.472 0 1.469.756 3.387 2.394 4.771-.612.188-1.363.479-1.845.835-.434.32-.379.646-.301.778.343.578 5.883.369 7.482.189 1.6.18 7.14.389 7.483-.189.078-.132.132-.458-.301-.778-.483-.356-1.233-.646-1.846-.836 1.637-1.384 2.393-3.302 2.393-4.771 0 0 1.563 2.537 2.103 2.472.251-.03.581-1.39-.438-4.673"/></svg>' },
        { key: 'wechat', label: '微信登录',   enabled: site.login_wechat_enabled === '1',
          svg: '<svg viewBox="0 0 24 24" fill="#07C160"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178A1.17 1.17 0 0 1 4.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 0 1-1.162 1.178 1.17 1.17 0 0 1-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 0 1 .598.082l1.584.926a.272.272 0 0 0 .14.047c.134 0 .24-.111.24-.247 0-.06-.023-.12-.038-.177l-.327-1.233a.582.582 0 0 1-.023-.156.49.49 0 0 1 .201-.398C23.024 18.48 24 16.82 24 14.98c0-3.21-2.931-5.837-6.656-6.088V8.89c-.135-.01-.27-.027-.407-.03zm-2.53 3.274c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.97-.982zm4.844 0c.535 0 .969.44.969.982a.976.976 0 0 1-.969.983.976.976 0 0 1-.969-.983c0-.542.434-.982.969-.982z"/></svg>' },
        { key: 'google', label: 'Google 登录', enabled: site.login_google_enabled === '1',
          svg: '<svg viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" fill="#fff" stroke="#e0e0e0" stroke-width="1"/><path d="M24 14a10 10 0 019 6h-4a6 6 0 00-10-2l-3-2A10 10 0 0124 14z" fill="#4285F4"/><path d="M18 22h12v4H18z" fill="#EA4335"/><path d="M24 34a10 10 0 01-9.5-7h4a6 6 0 0010 2l3 2a10 10 0 01-7.5 3z" fill="#34A853"/><path d="M14 22a10 10 0 01.5-3l-3.5-2A10 10 0 0010 24a10 10 0 001 5l3.5-2A6 6 0 0114 22z" fill="#FBBC05"/></svg>' },
    ].filter(s => s.enabled);

    const tabsHtml = emailEnabled ? `
        <div class="modal-tabs">
            <button class="modal-tab ${mode === 'login' ? 'active' : ''}" data-auth-tab="login">登录</button>
            <button class="modal-tab ${mode === 'register' ? 'active' : ''}" data-auth-tab="register">注册</button>
        </div>` : '';
    const emailFormHtml = emailEnabled ? `
        <div class="modal-error" id="authErr"></div>
        <div class="form-group"><label>邮箱</label><input type="email" class="form-input" id="authEmail" value="${escAttr(prefillEmail)}" placeholder="you@example.com" autocomplete="email"></div>
        <div class="form-group"><label>密码</label><input type="password" class="form-input" id="authPass" placeholder="至少 8 位，含字母和数字" autocomplete="${mode === 'login' ? 'current-password' : 'new-password'}"></div>
        <button class="btn btn-primary btn-block" id="authSubmit">${mode === 'login' ? '登 录' : '注 册'}</button>
        <div class="link-switch">${mode === 'login' ? (state.site.auth_no_account || '还没有账号？') : (state.site.auth_has_account || '已有账号？')}<a id="authSwitch">${mode === 'login' ? (state.site.auth_register_now || '立即注册') : (state.site.auth_go_login || '去登录')}</a></div>` : '';
    const dividerHtml = (emailEnabled && socials.length) ? '<div class="form-divider"><span>或使用以下方式</span></div>' : '';
    const socialsHtml = socials.length ? `
        <div class="social-login">${socials.map(s => `
            <button type="button" class="social-btn-row" data-social="${s.key}" title="${s.label}">
                <span class="social-icon">${s.svg}</span>
                <span>${s.label}</span>
            </button>`).join('')}
        </div>` : '';
    const forgotHtml = emailEnabled ? '<div class="form-links"><a href="#" id="forgotPwdLink">忘记密码？</a></div>' : '';

    openModal(`
        <div class="auth-header">
            <div class="auth-logo">🧭</div>
            <div class="auth-title">${mode === 'login' ? '欢迎回来' : '创建账号'}</div>
            <div class="auth-subtitle">${mode === 'login' ? '登录后继续同步你的专属导航' : '开启你的专属上网起始页'}</div>
        </div>
        ${tabsHtml}
        ${emailFormHtml}
        ${dividerHtml}
        ${socialsHtml}
        ${forgotHtml}
        <div class="modal-sub">游客数据会在登录后自动合并到你的账号</div>`);

    if (!emailEnabled && !socials.length) {
        // 理论上后台应至少保留一种；兜底提示
        showModalError('#authErr', '当前未开放任何登录方式，请联系管理员');
    }
    if (emailEnabled) {
        const submit = async () => {
            const email = $('#authEmail').value.trim();
            const pass = $('#authPass').value;
            try {
                const res = await apiPost(API.auth + '?action=' + mode, { email, password: pass });
                if (res.need_choice) {
                    closeModal();
                    showSyncChoiceModal(res);
                    return;
                }
                state.user = res.user;
                closeModal();
                renderProfile();
                toast(mode === 'login' ? '登录成功，数据已同步' : '注册成功，已自动登录', 'success');
                if (mode === 'register' && res.email_sent) {
                    setTimeout(() => toast('验证邮件已发送至你的邮箱，请查收', 'info'), 1200);
                }
                resetDataView();
                loadShortcuts(); loadTodos(); loadNotes(); loadSettings();
            } catch (e) {
                // 邮箱已存在：直接切到「登录」Tab 并回填邮箱，省去用户手点「去登录」再重输一遍
                if (e && e.status === 409 && mode === 'register') {
                    toast('该邮箱已注册，已为你切到登录', 'info');
                    showAuthModal('login', email);
                    showModalError('#authErr', '该邮箱已注册，请直接登录');
                    return;
                }
                showModalError('#authErr', e.message);
            }
        };
        $('#authSubmit').onclick = submit;
        $('#authPass').onkeydown = (e) => { if (e.key === 'Enter') submit(); };
        $('#authSwitch').onclick = () => showAuthModal(mode === 'login' ? 'register' : 'login', $('#authEmail').value.trim());
        $$('[data-auth-tab]').forEach(t => {
            t.onclick = () => showAuthModal(t.dataset.authTab, $('#authEmail').value.trim());
        });
        $('#forgotPwdLink').onclick = (e) => { e.preventDefault(); showForgotPasswordModal(); };
    }
    // 第三方登录：跳转 OAuth 授权页
    $$('.social-btn-row').forEach(b => {
        b.onclick = () => {
            const p = b.dataset.social;
            const names = { qq: 'QQ', wechat: '微信', google: 'Google' };
            toast('正在跳转' + (names[p] || p) + '授权…', 'info');
            setTimeout(() => { location.href = '/api/oauth.php?action=start&provider=' + encodeURIComponent(p); }, 350);
        };
    });
}

/**
 * 登录后同步方式选择：本地（游客）与云端（账户）都有数据时弹出，
 * 让用户在三者中抉择，避免默认强合并造成图标重叠/重复。
 * info = { need_choice, local:{shortcuts,todos,notes,settings}, cloud:{...} }
 */

export function showSyncChoiceModal(info) {
    const fmt = (c) => {
        c = c || {};
        const parts = [];
        if (c.shortcuts) parts.push(c.shortcuts + ' 个图标');
        if (c.todos) parts.push(c.todos + ' 条待办');
        if (c.notes) parts.push(c.notes + ' 条便签');
        if (c.settings) parts.push(c.settings + ' 项设置');
        return parts.join('、') || '暂无数据';
    };
    const cloudDesc = fmt(info.cloud);
    const localDesc = fmt(info.local);

    openModal(`
        <div class="auth-header">
            <div class="auth-logo">☁️</div>
            <div class="auth-title">选择同步方式</div>
            <div class="auth-subtitle">检测到本设备与云端都有数据，请选择如何处理</div>
        </div>
        <div class="sync-choice-list">
            <button type="button" class="sync-choice" id="syncChoiceCloud">
                <span class="sync-choice-icon">☁️</span>
                <span class="sync-choice-body">
                    <span class="sync-choice-title">以云端为准</span>
                    <span class="sync-choice-desc">丢弃本设备数据，使用云端：${cloudDesc}</span>
                </span>
            </button>
            <button type="button" class="sync-choice" id="syncChoiceLocal">
                <span class="sync-choice-icon">💻</span>
                <span class="sync-choice-body">
                    <span class="sync-choice-title">以本地为准</span>
                    <span class="sync-choice-desc">用本设备数据覆盖云端：${localDesc}</span>
                </span>
            </button>
            <button type="button" class="sync-choice primary" id="syncChoiceMerge">
                <span class="sync-choice-icon">🔀</span>
                <span class="sync-choice-body">
                    <span class="sync-choice-title">智能合并（推荐）</span>
                    <span class="sync-choice-desc">两侧数据合并去重，图标不重叠不重复</span>
                </span>
            </button>
        </div>
        <div class="modal-sub">选择后立即生效，之后登录同一账号即可在多设备间保持数据一致</div>`);

    const resolve = async (mode) => {
        // 提交中禁用三键，防止重复提交
        $$('.sync-choice').forEach(b => { b.disabled = true; b.classList.add('is-busy'); });
        try {
            const res = await apiPost(API.auth + '?action=login_resolve', { mode });
            state.user = res.user;
            closeModal();
            renderProfile();
            toast('登录成功，数据已同步', 'success');
            resetDataView();
            loadShortcuts(); loadTodos(); loadNotes(); loadSettings();
        } catch (e) {
            $$('.sync-choice').forEach(b => { b.disabled = false; b.classList.remove('is-busy'); });
            toast(e.message || '同步失败，请重试', 'error');
            showAuthModal('login');
        }
    };
    $('#syncChoiceCloud').onclick = () => resolve('cloud');
    $('#syncChoiceLocal').onclick = () => resolve('local');
    $('#syncChoiceMerge').onclick = () => resolve('merge');
}


export function showForgotPasswordModal() {
    openModal(`
        <div class="modal-title">找回密码</div>
        <div class="modal-sub" style="margin-bottom:16px">输入注册邮箱，我们将向您发送密码重置链接</div>
        <div class="modal-error" id="fpErr"></div>
        <div class="form-group"><label>注册邮箱</label><input type="email" class="form-input" id="fpEmail" placeholder="you@example.com" autocomplete="email"></div>
        <button class="btn btn-primary btn-block" id="fpSubmit">发送重置链接</button>
        <div class="modal-actions" style="margin-top:12px"><button class="btn btn-light btn-block" data-close-modal>返回登录</button></div>`);
    $('#fpSubmit').onclick = async () => {
        const email = $('#fpEmail').value.trim();
        if (!email) { showModalError('#fpErr', '请输入邮箱地址'); return; }
        try {
            const res = await apiPost(API.auth + '?action=forgot_password', { email });
            closeModal();
            toast(res.message || '重置链接已发送', 'success');
        } catch (e) { showModalError('#fpErr', e.message); }
    };
    $('#fpEmail').onkeydown = (e) => { if (e.key === 'Enter') $('#fpSubmit').click(); };
}

export function showAccountModal() {
    const u = state.user;
    if (!u) return;
    const avatarHtml = u.avatar_url
        ? `<img src="${escAttr(u.avatar_url)}" alt="">`
        : `<img src="/assets/img/avatar-default.png" alt="" style="width:100%;height:100%;object-fit:cover">`;
    openModal(`
        <div class="modal-tabs">
            <button class="modal-tab active" data-acc-tab="profile">基本信息</button>
            <button class="modal-tab" data-acc-tab="security">账号设置</button>
        </div>
        <div class="modal-error" id="accErr"></div>

        <!-- Tab 1: 基本信息 -->
        <div class="modal-tab-panel active" data-acc-panel="profile">
            <div class="avatar-upload-area">
                <div class="avatar-large" id="accAvatar" style="background:${u.avatar_color || '#5B8DD4'}">${avatarHtml}</div>
                <label class="avatar-upload-btn">
                    更换头像
                    <input type="file" id="accAvatarFile" accept="image/png,image/jpeg,image/gif,image/webp" style="display:none">
                </label>
                <div class="avatar-hint">未上传头像时显示默认图标 · 支持 JPG/PNG/GIF/WebP，最大 2MB</div>
            </div>
            <div class="form-group"><label>昵称</label><input type="text" class="form-input" id="accNickname" value="${escAttr(u.nickname || '')}" maxlength="20" placeholder="展示昵称"></div>
            <button class="btn btn-primary btn-block" id="accSave">保存资料</button>
        </div>

        <!-- Tab 2: 账号设置 -->
        <div class="modal-tab-panel" data-acc-panel="security">
            <div class="bound-row">
                <div>
                    <div class="bound-label">邮箱${u.email_verified ? '<span class="bound-badge">✓ 已验证</span>' : ''}</div>
                    <div class="bound-value">${esc(u.email || '')}</div>
                </div>
                <button class="btn-link-sm" id="accChangeEmail">更换</button>
            </div>
            <div class="bound-row" id="phoneRow">
                <div>
                    <div class="bound-label">手机${u.phone_verified ? '<span class="bound-badge">✓ 已绑定</span>' : ''}</div>
                    <div class="bound-value">${u.phone ? esc(u.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')) : '未绑定'}</div>
                </div>
                ${u.phone ? '<button class="btn-link-sm danger" id="accUnbindPhone">解绑</button>' : '<button class="btn-link-sm" id="accBindPhone">绑定</button>'}
            </div>
            <div style="height:8px"></div>
            <div class="form-group"><label>原密码</label><input type="password" class="form-input" id="accOldPass" placeholder="当前密码" autocomplete="current-password"></div>
            <div class="form-group"><label>新密码</label><input type="password" class="form-input" id="accNewPass" placeholder="至少 8 位，含字母和数字" autocomplete="new-password"></div>
            <button class="btn btn-light btn-block" id="accPassSave">修改密码</button>
            <div style="height:16px"></div>
            ${u.email_verified ? '' : '<button class="btn btn-light btn-block" id="accVerifyEmail">📧 发送验证邮件</button><div style="height:8px"></div>'}
            <button class="btn btn-outline-danger btn-block" id="accLogout">退出登录</button>
            <div style="height:8px"></div>
            <button class="btn btn-outline-danger btn-block" id="accDeleteAccount">注销账号</button>
        </div>

        <div class="modal-actions" style="margin-top:16px"><button class="btn btn-light" data-close-modal>关闭</button></div>`);

    // Tab 切换
    $$('[data-acc-tab]').forEach(t => {
        t.onclick = () => {
            $$('[data-acc-tab]').forEach(x => x.classList.remove('active'));
            t.classList.add('active');
            $$('[data-acc-panel]').forEach(p => p.classList.toggle('active', p.dataset.accPanel === t.dataset.accTab));
        };
    });

    // 默认头像已改为爱微圈图标，不再提供文字/颜色头像编辑

    // 头像上传
    $('#accAvatarFile').onchange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) { showModalError('#accErr', '图片不能超过 2MB'); return; }
        const fd = new FormData();
        fd.append('avatar', file);
        try {
            const res = await fetch(API.auth + '?action=upload_avatar', {
                method: 'POST',
                headers: { 'X-CSRF-Token': state.csrf },
                body: fd,
            }).then(r => r.json());
            if (res.error) throw new Error(res.error);
            state.user = res.user;
            u.avatar_url = res.user.avatar_url;
            const a = $('#accAvatar');
            a.innerHTML = `<img src="${escAttr(res.user.avatar_url)}" alt="">`;
            a.style.background = 'none';
            renderProfile();
            toast('头像已更新', 'success');
        } catch (e2) { showModalError('#accErr', e2.message); }
    };

    $('#accSave').onclick = async () => {
        try {
            const res = await apiPost(API.auth + '?action=update_profile', {
                nickname: $('#accNickname').value.trim(),
                avatar_text: '',
                avatar_color: state.user.avatar_color || '#5B8DD4',
            });
            state.user = res.user;
            closeModal();
            renderProfile();
            toast('资料已更新', 'success');
        } catch (e) { showModalError('#accErr', e.message); }
    };
    $('#accPassSave').onclick = async () => {
        try {
            await apiPost(API.auth + '?action=change_password', {
                old_password: $('#accOldPass').value, new_password: $('#accNewPass').value,
            });
            $('#accOldPass').value = ''; $('#accNewPass').value = '';
            toast('密码已修改', 'success');
        } catch (e) { showModalError('#accErr', e.message); }
    };

    // 手机绑定
    const bindBtn = $('#accBindPhone');
    if (bindBtn) bindBtn.onclick = () => showPhoneBindModal();
    const unbindBtn = $('#accUnbindPhone');
    if (unbindBtn) unbindBtn.onclick = async () => {
        if (!await modalConfirm('解绑手机', '确定要解绑当前手机号吗？')) return;
        try {
            const res = await apiPost(API.auth + '?action=unbind_phone', {});
            state.user = res.user;
            closeModal();
            toast('手机已解绑', 'success');
            showAccountModal();
        } catch (e) { showModalError('#accErr', e.message); }
    };

    // 邮箱更换
    $('#accChangeEmail').onclick = () => showEmailChangeModal();

    // 发送邮箱验证邮件
    const verifyBtn = $('#accVerifyEmail');
    if (verifyBtn) verifyBtn.onclick = async () => {
        verifyBtn.disabled = true;
        verifyBtn.textContent = '发送中…';
        try {
            const res = await apiPost(API.auth + '?action=send_verification', {});
            toast(res.message || '验证邮件已发送', 'success');
            closeModal();
        } catch (e) {
            showModalError('#accErr', e.message);
            verifyBtn.disabled = false;
            verifyBtn.textContent = '📧 发送验证邮件';
        }
    };

    // 注销账号（危险操作：二次弹窗 + 密码确认）
    $('#accDeleteAccount').onclick = () => showDeleteAccountModal();

    // 退出登录
    $('#accLogout').onclick = async () => {
        closeModal();
        await doLogout();
    };
}


export function showDeleteAccountModal() {
    openModal(`
        <div class="modal-title" style="color:#e1251b">注销账号</div>
        <div class="modal-sub" style="margin-bottom:12px">此操作<b>不可恢复</b>，将永久删除：</div>
        <ul style="font-size:13px;color:var(--text-dim);line-height:1.9;margin:0 0 12px;padding-left:20px">
            <li>全部快捷方式、文件夹与页面</li>
            <li>全部待办事项与便签</li>
            <li>个性化设置与云端备份/快照</li>
            <li>上传的图标与头像文件</li>
        </ul>
        <div style="font-size:13px;color:#e1251b;margin-bottom:8px">删除前建议先在侧栏「导入导出」中备份数据</div>
        <div class="modal-error" id="delErr"></div>
        <div class="form-group"><label>输入登录密码确认</label><input type="password" class="form-input" id="delPass" placeholder="登录密码" autocomplete="current-password"></div>
        <button class="btn btn-outline-danger btn-block" id="delSubmit">确认注销并删除全部数据</button>
        <div class="modal-actions" style="margin-top:12px"><button class="btn btn-light btn-block" data-close-modal>取消</button></div>`);
    $('#delSubmit').onclick = async () => {
        try {
            await apiPost(API.auth + '?action=delete_account', { password: $('#delPass').value });
            try { localStorage.removeItem(cacheKey()); } catch (e) { /* 忽略 */ }
            toast('账号已注销，数据已删除', 'success');
            setTimeout(() => location.reload(), 800);
        } catch (e) { showModalError('#delErr', e.message); }
    };
    $('#delPass').onkeydown = (e) => { if (e.key === 'Enter') $('#delSubmit').click(); };
}


export function showPhoneBindModal() {
    openModal(`
        <div class="modal-title">绑定手机</div>
        <div class="modal-error" id="pbErr"></div>
        <div class="form-group"><label>手机号</label><input type="tel" class="form-input" id="pbPhone" placeholder="请输入11位手机号" maxlength="11"></div>
        <div class="form-group"><label>验证码</label>
            <div class="code-input-group">
                <input type="text" class="form-input" id="pbCode" placeholder="6位验证码" maxlength="6">
                <button class="code-btn" id="pbSendCode">获取验证码</button>
            </div>
        </div>
        <button class="btn btn-primary btn-block" id="pbSubmit">确认绑定</button>
        <div class="modal-actions" style="margin-top:12px"><button class="btn btn-light" data-close-modal>取消</button></div>`);
    let countdown = 0;
    const startCountdown = () => {
        countdown = 60;
        const btn = $('#pbSendCode');
        btn.disabled = true;
        const timer = setInterval(() => {
            countdown--;
            if (countdown <= 0) { clearInterval(timer); btn.textContent = '获取验证码'; btn.disabled = false; }
            else btn.textContent = countdown + 's';
        }, 1000);
    };
    $('#pbSendCode').onclick = async () => {
        const phone = $('#pbPhone').value.trim();
        if (!/^1[3-9]\d{9}$/.test(phone)) { showModalError('#pbErr', '请输入有效的手机号'); return; }
        try {
            const res = await apiPost(API.auth + '?action=send_phone_code', { phone });
            toast(res.message || '验证码已发送', 'success');
            startCountdown();
        } catch (e) { showModalError('#pbErr', e.message); }
    };
    $('#pbSubmit').onclick = async () => {
        const phone = $('#pbPhone').value.trim();
        const code = $('#pbCode').value.trim();
        if (!phone || !code) { showModalError('#pbErr', '请填写手机号和验证码'); return; }
        try {
            const res = await apiPost(API.auth + '?action=bind_phone', { phone, code });
            state.user = res.user;
            closeModal();
            renderProfile();
            toast('手机绑定成功', 'success');
            showAccountModal();
        } catch (e) { showModalError('#pbErr', e.message); }
    };
}


export function showEmailChangeModal() {
    const u = state.user;
    openModal(`
        <div class="modal-title">更换邮箱</div>
        <div class="modal-sub" style="margin-bottom:12px">当前邮箱：${esc(u.email || '')}</div>
        <div class="modal-error" id="ecErr"></div>
        <div class="form-group"><label>新邮箱</label><input type="email" class="form-input" id="ecEmail" placeholder="new@example.com"></div>
        <div class="form-group"><label>当前密码</label><input type="password" class="form-input" id="ecPass" placeholder="验证身份" autocomplete="current-password"></div>
        <button class="btn btn-primary btn-block" id="ecSubmit">确认更换</button>
        <div class="modal-actions" style="margin-top:12px"><button class="btn btn-light" data-close-modal>取消</button></div>`);
    $('#ecSubmit').onclick = async () => {
        const email = $('#ecEmail').value.trim();
        const password = $('#ecPass').value;
        if (!email || !password) { showModalError('#ecErr', '请填写新邮箱和当前密码'); return; }
        try {
            const res = await apiPost(API.auth + '?action=change_email', { email, password });
            state.user = res.user;
            closeModal();
            renderProfile();
            toast('邮箱已更换，请查收验证邮件', 'success');
            showAccountModal();
        } catch (e) { showModalError('#ecErr', e.message); }
    };
}

// 登录 / 退出 / 同步方式选择后：清空内存数据缓存与分页状态，
// 避免上一身份（游客或另一账号）预取的图标/页号残留在当前视图。

export function resetDataView() {
    state.shortcutCache = {};
    state.pages = [1];
    state.currentPage = 1;
    state.todos = [];
    state.notes = [];
}


export async function doLogout() {
    try {
        await apiPost(API.auth + '?action=logout', {});
    } catch (e) { /* ignore */ }
    const keyBeforeLogout = cacheKey();
    state.user = null;
    try { localStorage.removeItem(keyBeforeLogout); } catch (e) { /* 忽略：清掉本机首屏缓存残留 */ }
    resetDataView();
    renderProfile();
    loadShortcuts(); loadTodos(); loadNotes(); loadSettings();
    toast('已退出登录', 'success');
}

/* ---------- 设置 ---------- */

export async function loadUserCategories() {
    try {
        const all = await apiGet(API.shortcuts + '?action=all_categories');
        const cats = all.categories || [];
        const dl = $('#userCategoryList');
        if (dl) dl.innerHTML = cats.map(c => `<option value="${escAttr(c)}">`).join('');
    } catch(e) {}
}


export function showCategoryMgr() {
    if (gateGuest()) return; // 分组管理属登录限定（2026-09-04 策略）
    const renderCats = (cats, counts) => {
        return cats.map(cat => {
            const count = counts[cat] || 0;
            const isDefault = cat === '常用推荐';
            let actionHtml = '';
            if (isDefault) {
                actionHtml = '<span style="font-size:11px;color:rgba(255,255,255,0.4)">默认分组</span>';
            } else if (count > 0) {
                actionHtml = `<button class="cat-del" data-cat="${escAttr(cat)}" data-action="move">移到常用</button>`;
            } else {
                actionHtml = `<button class="cat-del" data-cat="${escAttr(cat)}" data-action="delete">删除</button>`;
            }
            return `<div class="cat-row" data-cat="${escAttr(cat)}">
                <span class="cat-name" contenteditable="true" spellcheck="false" style="flex:1;font-size:14px;font-weight:500;color:#fff;outline:none;padding:4px 8px;border-radius:6px">${esc(cat)}</span>
                <span style="font-size:12px;color:rgba(255,255,255,0.4);flex-shrink:0">${count} 个</span>
                ${actionHtml}
            </div>`;
        }).join('');
    };

    const loadCats = async () => {
        const body = $('#catMgrBody');
        if (!body) return;
        try {
            const all = await apiGet(API.shortcuts + '?action=all_categories');
            const cats = all.categories || [];
            const counts = all.counts || {};
            body.innerHTML = `
                <div style="padding:8px 14px;font-size:12px;color:rgba(255,255,255,0.5);background:rgba(255,255,255,0.06);border-radius:8px;margin-bottom:8px">
                    双击分组名称可重命名 · 删除分组后快捷方式移到"常用推荐"
                </div>
                ${renderCats(cats, counts)}
                <div style="padding:12px;border-top:1px solid rgba(255,255,255,0.08);margin-top:4px">
                    <div style="display:flex;gap:8px">
                        <input type="text" id="newCatName" placeholder="新分组名称" style="flex:1;padding:9px 12px;border-radius:8px;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.08);color:#fff;font-size:14px">
                        <button id="addCatBtn" style="padding:9px 16px;border-radius:8px;background:#4A90D9;color:#fff;border:none;cursor:pointer;font-size:13px">添加</button>
                    </div>
                </div>`;
            bindEvents(body);
        } catch(e) {
            body.innerHTML = `<div style="padding:20px;text-align:center;color:#999">加载失败: ${esc(e.message)}</div>`;
        }
    };

    const bindEvents = (body) => {
        // 事件委托：删除/移动
        body.onclick = async (e) => {
            const btn = e.target.closest('.cat-del');
            if (btn) {
                const cat = btn.dataset.cat;
                const action = btn.dataset.action;
                try {
                    if (action === 'delete') {
                        await apiPost(API.shortcuts + '?action=delete_category', { category: cat });
                        toast('分组已删除', 'success');
                    } else if (action === 'move') {
                        await apiPost(API.shortcuts + '?action=move_category', { from: cat, to: '常用推荐' });
                        toast('已移到常用推荐', 'success');
                    }
                    loadCats(); loadUserCategories(); renderShortcuts();
                } catch(err) { toast('操作失败: ' + err.message, 'error'); }
                return;
            }
            // 添加按钮
            const addBtn = e.target.closest('#addCatBtn');
            if (addBtn) {
                const input = $('#newCatName');
                if (!input) return;
                const name = input.value.trim();
                if (!name) { toast('请输入分组名称', 'error'); return; }
                try {
                    await apiPost(API.shortcuts + '?action=create_category', { category: name });
                    toast('分组已添加', 'success');
                    loadCats(); loadUserCategories();
                } catch(err) { toast('添加失败: ' + err.message, 'error'); }
                return;
            }
        };
        // 重命名 + 回车添加
        body.onkeydown = async (e) => {
            if (e.key !== 'Enter') return;
            if (e.target.classList.contains('cat-name')) {
                e.preventDefault();
                const row = e.target.closest('.cat-row');
                if (!row) return;
                const oldName = row.dataset.cat;
                const newName = e.target.textContent.trim();
                if (!newName || newName === oldName) { e.target.textContent = oldName; return; }
                try {
                    await apiPost(API.shortcuts + '?action=rename_category', { old: oldName, new: newName });
                    toast('已重命名', 'success');
                    row.dataset.cat = newName;
                    state.shortcutCache = {};
                    loadUserCategories(); renderShortcuts();
                } catch(err) { toast(err.message, 'error'); e.target.textContent = oldName; }
                e.target.blur();
            } else if (e.target.id === 'newCatName') {
                e.preventDefault();
                $('#addCatBtn')?.click();
            }
        };
    };

    openModal(`
        <div class="modal-title">分组管理</div>
        <div id="catMgrBody" style="max-height:400px;overflow-y:auto"><div style="padding:20px;text-align:center;color:#999">加载中…</div></div>
        <div class="modal-actions" style="margin-top:12px">
            <button class="btn btn-light" data-close-modal>关闭</button>
        </div>
    `);

    loadCats();
}


/* ==================== 推荐网站入库（提交管理员审核） ==================== */

/* 对接后端 api/websites.php?action=submit_site → user_sites 表（status=0），
 * 由后台「网站审核」（admin/site_reviews.php）通过后进入公共网站库。
 * 体验对齐自定义添加向导：输入链接后自动抓取名称/描述/图标。 */
export async function showSiteReviewModal() {
    if (!state.user) {
        toast('请先登录后再推荐网站', 'error');
        showAuthModal('login');
        return;
    }
    if (!state.categories || !state.categories.length) {
        try { await loadCategories(); } catch (e) {}
    }
    // 默认选中「用户分享」分组（审核通过后默认归入该分组）
    const catList = (state.categories || []).map(c => c.name);
    const defaultCat = catList.includes('用户分享') ? '用户分享' : (catList[0] || '常用推荐');
    const catOptions = (state.categories || [])
        .map(c => `<option value="${escAttr(c.name)}"${c.name === defaultCat ? ' selected' : ''}>${esc(c.name)}</option>`).join('');

    openModal(`
        <div class="modal-title">推荐网站入库</div>
        <div style="font-size:12.5px;color:var(--text-faint);margin:2px 0 14px;line-height:1.6">
            把好用的网站推荐给所有用户。提交后进入管理员审核队列，审核通过即收入公共网站库（默认归入「用户分享」分组）。
        </div>
        <div class="modal-error" id="reviewErr"></div>
        <div class="form-group"><label>网站地址 *</label>
            <div style="display:flex;gap:8px;align-items:center">
                <input type="text" class="form-input" id="revUrl" placeholder="https://example.com（输入后自动识别）" style="flex:1;min-width:0">
                <div id="revIconPrev" style="width:44px;height:44px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:17px;font-weight:700;color:#fff;background:#5B8DD4;flex-shrink:0;overflow:hidden">网</div>
            </div>
            <div id="revFetchStatus" style="margin-top:5px;font-size:12px;color:var(--text-faint);min-height:16px"></div>
        </div>
        <div class="form-group"><label>网站名称 *</label><input type="text" class="form-input" id="revName" placeholder="例如：GitHub" maxlength="60"></div>
        <div class="form-group"><label>网站描述</label><input type="text" class="form-input" id="revDesc" placeholder="一句话介绍（选填，最多 200 字）" maxlength="200"></div>
        <div class="form-group"><label>推荐分组（建议，审核时可调整）</label>
            <select class="form-input" id="revCategory">${catOptions || '<option value="用户分享">用户分享</option>'}</select>
        </div>
        <div class="modal-actions" style="margin-top:16px">
            <button class="btn btn-light" data-close-modal>取消</button>
            <button class="btn btn-primary" id="revSubmit">提交审核</button>
        </div>
    `);

    /* 自动抓取：输入链接 → site_info 接口 → 名称/描述/图标（同自定义添加向导） */
    const wizard = { edited: false, name: '', icon_url: '', icon_color: '#5B8DD4', icon_text: '' };
    const updatePreview = () => {
        const el = $('#revIconPrev');
        if (!el) return;
        if (wizard.icon_url) {
            el.innerHTML = `<img src="${escAttr(wizard.icon_url)}" alt="" style="width:64%;height:64%;object-fit:contain">`;
            el.style.background = '#fff';
        } else {
            el.textContent = wizard.icon_text || (wizard.name || '网').charAt(0).toUpperCase() || '网';
            el.style.background = wizard.icon_color;
        }
    };
    const fetchInfo = debounce(async () => {
        const url = ($('#revUrl')?.value || '').trim();
        if (url.length < 5 || !url.includes('.')) return;
        const st = $('#revFetchStatus');
        if (st) st.textContent = '正在识别网站信息…';
        try {
            const info = await apiGet(API.site_info + '?url=' + encodeURIComponent(url));
            if (info && !info.error) {
                if (!wizard.edited && info.title) {
                    wizard.name = info.title.substring(0, 60);
                    $('#revName').value = wizard.name;
                }
                if (info.description && !$('#revDesc').value) $('#revDesc').value = info.description.substring(0, 200);
                if (info.icon_text) wizard.icon_text = info.icon_text;
                if (info.icon_color) wizard.icon_color = info.icon_color;
                if (info.icon) wizard.icon_url = info.icon;
                updatePreview();
                if (st) st.textContent = '已识别：' + (info.title || url);
            }
        } catch (e) {
            if (st) st.textContent = '自动识别失败，可手动填写';
        }
    }, 500);
    $('#revUrl').oninput = fetchInfo;
    $('#revUrl').onblur = fetchInfo;
    $('#revName').oninput = () => { wizard.edited = true; wizard.name = $('#revName').value; if (!wizard.icon_url) updatePreview(); };

    const doSubmit = async () => {
        const name = ($('#revName')?.value || '').trim();
        const url = ($('#revUrl')?.value || '').trim();
        const description = ($('#revDesc')?.value || '').trim();
        const category = ($('#revCategory')?.value || '').trim();
        const errBox = $('#reviewErr');
        if (errBox) errBox.textContent = '';
        if (!name) { if (errBox) errBox.textContent = '请填写网站名称'; return; }
        if (!/^https?:\/\/.+\..+/i.test(url)) { if (errBox) errBox.textContent = '请填写有效的网站地址（http/https）'; return; }

        const btn = $('#revSubmit');
        if (btn) { btn.disabled = true; btn.textContent = '提交中…'; }
        const ok = await submitSiteForReview({
            name, url, description, category,
            icon_url: wizard.icon_url || '',
            icon_color: wizard.icon_color,
            icon_text: wizard.icon_text || ''
        });
        if (ok) {
            closeModal();
        } else if (btn) {
            btn.disabled = false;
            btn.textContent = '提交审核';
        }
    };

    $('#revSubmit').onclick = doSubmit;
    $('#revUrl').onkeydown = (e) => { if (e.key === 'Enter') doSubmit(); };
    $('#revName').onkeydown = (e) => { if (e.key === 'Enter') $('#revDesc')?.focus(); };
}


export async function showCustomAddModal() {
    if (gateGuest()) return; // 自定义添加属登录限定（2026-09-04 策略）
    const isCard = state.settings.display_mode === 'card';
    let catOptions = '<option value="常用推荐" selected>常用推荐</option>';
    try {
        const all = await apiGet(API.shortcuts + '?action=all_categories');
        catOptions = (all.categories || []).map(c => `<option value="${escAttr(c)}">${esc(c)}</option>`).join('');
    } catch(e) {}

    // 向导弹力数据
    const wizard = {
        step: 1,
        url: '',
        name: '',
        description: '',
        category: '常用推荐',
        icon_text: '',
        icon_color: '#5B8DD4',
        icon_url: '',
        icon_font_size: 14,
        info: null,
        edited: false,
    };

    openModal(`
        <div class="wizard-steps" id="wizSteps">
            <div class="wizard-step-dot active" data-step="1">1</div>
            <div class="wizard-step-line"></div>
            <div class="wizard-step-dot" data-step="2">2</div>
        </div>
        <div class="modal-error" id="wizErr"></div>

        <!-- Step 1: 网址 + 名称 -->
        <div class="wizard-panel" data-panel="1">
            <div style="display:flex;align-items:center;gap:14px;padding:16px;background:var(--glass);border-radius:14px;margin-bottom:16px">
                <div id="wizIcon" style="width:56px;height:56px;border-radius:14px;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:700;color:#fff;background:#5B8DD4;flex-shrink:0;overflow:hidden;box-shadow:0 4px 14px rgba(0,0,0,0.12)">网</div>
                <div style="flex:1;min-width:0">
                    <div id="wizNamePrev" style="font-size:15px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">网站名称</div>
                    <div id="wizDescPrev" style="font-size:12px;color:var(--text-faint);margin-top:3px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">输入网址后自动获取信息</div>
                </div>
            </div>
            <div class="form-group"><label>网站地址 *</label><input type="text" class="form-input" id="wizUrl" placeholder="https://example.com"></div>
            <div class="form-group"><label>网站名称 *</label><input type="text" class="form-input" id="wizName" placeholder="网站名称" maxlength="50"></div>
            <div class="form-group"><label>网站描述</label><input type="text" class="form-input" id="wizDesc" placeholder="网站描述（详细模式下显示）" maxlength="200"></div>
            ${isCard ? `<div class="form-group"><label>分组</label><select class="form-input" id="wizCategory">${catOptions}</select></div>` : ''}
            <div class="wizard-actions">
                <button class="btn btn-light" data-close-modal>取消</button>
                <button class="btn btn-primary" id="wizNext">下一步</button>
            </div>
        </div>

        <!-- Step 2: 图标样式 -->
        <div class="wizard-panel" data-panel="2" style="display:none">
            <div style="text-align:center;margin-bottom:16px">
                <div id="wizIconLarge" style="width:72px;height:72px;border-radius:18px;display:inline-flex;align-items:center;justify-content:center;font-size:28px;font-weight:700;color:#fff;background:#5B8DD4;overflow:hidden;box-shadow:0 6px 20px rgba(0,0,0,0.15)">网</div>
            </div>
            <div class="form-group"><label>图标方式</label>
                <div class="icon-picker-grid" id="wizIconPicker">
                    <div class="icon-picker-item selected" data-iconmode="auto" title="自动获取"><span class="letter">A</span></div>
                    <div class="icon-picker-item" data-iconmode="text" title="文字图标"><span class="letter">T</span></div>
                    <div class="icon-picker-item" data-iconmode="upload" title="上传图片"><span style="font-size:20px">📷</span></div>
                </div>
            </div>
            <div id="wizTextOpts" style="display:none">
                <div style="display:flex;gap:10px;margin-bottom:12px">
                    <div style="flex:1"><label>图标文字</label><input type="text" class="form-input" id="wizIconText" placeholder="1-2字" maxlength="2" style="text-align:center"></div>
                    <div style="width:80px"><label>颜色</label><input type="color" class="form-input" id="wizIconColor" value="#5B8DD4" style="height:42px;padding:4px"></div>
                </div>
            </div>
            <div id="wizUploadOpts" style="display:none">
                <label class="icon-upload-area" id="wizUploadArea">
                    <svg viewBox="0 0 24 24"><path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"/></svg>
                    <p>点击或拖拽图片到此处上传</p>
                    <p style="font-size:10px;color:var(--text-faint);margin-top:4px">PNG/JPG/WebP，最大 2MB</p>
                    <input type="file" id="wizIconFile" accept="image/png,image/jpeg,image/gif,image/webp,image/x-icon" style="display:none">
                </label>
            </div>
            <div class="form-group"><label>显示名称字号</label>
                <div class="settings-slider"><input type="range" min="10" max="24" id="wizFontSize" value="14"><span class="slider-value" id="wizFontSizeVal">14px</span></div>
            </div>
            <div class="wizard-actions">
                <button class="btn btn-light" id="wizPrev">上一步</button>
                <button class="btn btn-primary" id="wizSubmit">＋ 添加网站</button>
            </div>
        </div>
    `);

    // 动态加载分组
    try {
        const all = await apiGet(API.shortcuts + '?action=all_categories');
        const presets = ['常用推荐', '工具', '社交', '资讯', '购物', '视频', '游戏', '开发', '其他'];
        const cats = [...new Set([...presets, ...(all.categories || [])])];
        const dl = $('#catList');
        if (dl) dl.innerHTML = cats.map(c => `<option value="${escAttr(c)}">`).join('');
    } catch(e) {}

    const goStep = (n) => {
        wizard.step = n;
        $$('.wizard-panel').forEach(p => p.style.display = p.dataset.panel === String(n) ? '' : 'none');
        $$('.wizard-step-dot').forEach(d => {
            const sn = Number(d.dataset.step);
            d.classList.toggle('active', sn === n);
            d.classList.toggle('done', sn < n);
        });
        $$('.wizard-step-line').forEach((l, i) => l.classList.toggle('done', i + 1 < n));
    };

    const updatePreview = () => {
        const iconEl = $('#wizIcon');
        const iconLarge = $('#wizIconLarge');
        [iconEl, iconLarge].forEach(el => {
            if (!el) return;
            if (wizard.icon_url) {
                el.innerHTML = `<img src="${escAttr(wizard.icon_url)}" style="width:64%;height:64%;object-fit:contain">`;
                el.style.background = '#fff';
            } else {
                el.textContent = wizard.icon_text || (wizard.name || '网').charAt(0).toUpperCase();
                el.style.background = wizard.icon_color;
            }
        });
        $('#wizNamePrev').textContent = wizard.name || '网站名称';
        $('#wizDescPrev').textContent = wizard.description || (wizard.url ? wizard.url : '输入网址后自动获取信息');
    };

    // 自动获取网站信息
    const fetchInfo = debounce(async () => {
        const url = $('#wizUrl').value.trim();
        wizard.url = url;
        if (url.length < 5 || !url.includes('.')) return;
        $('#wizDescPrev').textContent = '正在获取…';
        try {
            const info = await apiGet(API.site_info + '?url=' + encodeURIComponent(url));
            if (info && !info.error) {
                wizard.info = info;
                if (!wizard.edited && info.title) {
                    wizard.name = info.title.substring(0, 50);
                    $('#wizName').value = wizard.name;
                }
                if (info.description && !wizard.description) {
                    wizard.description = info.description.substring(0, 200);
                    $('#wizDesc').value = wizard.description;
                }
                if (info.icon_text) { wizard.icon_text = info.icon_text; $('#wizIconText').value = info.icon_text; }
                if (info.icon_color) { wizard.icon_color = info.icon_color; $('#wizIconColor').value = info.icon_color; }
                if (info.icon) wizard.icon_url = info.icon;
                updatePreview();
            }
        } catch(e) {
            $('#wizDescPrev').textContent = '获取失败，可手动填写';
        }
    }, 500);

    $('#wizUrl').oninput = () => { wizard.url = $('#wizUrl').value; fetchInfo(); };
    $('#wizUrl').onblur = fetchInfo;
    $('#wizName').oninput = () => { wizard.edited = true; wizard.name = $('#wizName').value; $('#wizNamePrev').textContent = wizard.name || '网站名称'; };
    $('#wizDesc').oninput = () => { wizard.description = $('#wizDesc').value; $('#wizDescPrev').textContent = wizard.description || '描述'; };
    if (isCard) $('#wizCategory').onchange = () => { wizard.category = $('#wizCategory').value; };

    // 图标模式选择
    $$('#wizIconPicker .icon-picker-item').forEach(item => {
        item.onclick = () => {
            $$('#wizIconPicker .icon-picker-item').forEach(x => x.classList.remove('selected'));
            item.classList.add('selected');
            const mode = item.dataset.iconmode;
            $('#wizTextOpts').style.display = mode === 'text' ? '' : 'none';
            $('#wizUploadOpts').style.display = mode === 'upload' ? '' : 'none';
            if (mode === 'auto') {
                wizard.icon_url = wizard.info?.icon || '';
                wizard.icon_text = $('#wizIconText').value || (wizard.name || '网').charAt(0);
                updatePreview();
            } else if (mode === 'text') {
                wizard.icon_url = '';
                updatePreview();
            }
        };
    });

    $('#wizIconText').oninput = () => { wizard.icon_text = $('#wizIconText').value; updatePreview(); };
    $('#wizIconColor').oninput = () => { wizard.icon_color = $('#wizIconColor').value; updatePreview(); };
    $('#wizFontSize').oninput = () => {
        wizard.icon_font_size = Number($('#wizFontSize').value);
        $('#wizFontSizeVal').textContent = wizard.icon_font_size + 'px';
    };

    // 图标上传
    const uploadIcon = async (file) => {
        if (!file) return;
        if (file.size > 2 * 1024 * 1024) { showModalError('#wizErr', '图片不能超过 2MB'); return; }
        const fd = new FormData();
        fd.append('icon', file);
        try {
            const res = await fetch(API.shortcuts + '?action=upload_icon', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'X-CSRF-Token': state.csrf }, body: fd,
            });
            const data = JSON.parse(await res.text());
            if (!res.ok) throw new Error(data.error || '上传失败');
            wizard.icon_url = data.icon_url;
            updatePreview();
            toast('图标已上传', 'success');
        } catch(e) { showModalError('#wizErr', e.message); }
    };
    $('#wizIconFile').onchange = (e) => uploadIcon(e.target.files[0]);
    // 拖拽上传
    const uploadArea = $('#wizUploadArea');
    if (uploadArea) {
        uploadArea.ondragover = (e) => { e.preventDefault(); uploadArea.style.borderColor = 'var(--accent)'; };
        uploadArea.ondragleave = () => { uploadArea.style.borderColor = ''; };
        uploadArea.ondrop = (e) => { e.preventDefault(); uploadArea.style.borderColor = ''; if (e.dataTransfer.files[0]) uploadIcon(e.dataTransfer.files[0]); };
    }

    // 导航
    $('#wizNext').onclick = () => {
        if (!$('#wizUrl').value.trim()) { showModalError('#wizErr', '请输入网址'); return; }
        if (!$('#wizName').value.trim()) { showModalError('#wizErr', '请输入网站名称'); return; }
        wizard.url = $('#wizUrl').value.trim();
        wizard.name = $('#wizName').value.trim();
        wizard.description = $('#wizDesc').value.trim();
        if (isCard) wizard.category = $('#wizCategory').value;
        updatePreview();
        goStep(2);
    };
    $('#wizPrev').onclick = () => goStep(1);

    // 提交
    $('#wizSubmit').onclick = async () => {
        const btn = $('#wizSubmit');
        btn.disabled = true; btn.textContent = '添加中…';
        try {
            await apiPost(API.shortcuts + '?action=create', {
                name: wizard.name,
                url: wizard.url,
                description: wizard.description,
                category: wizard.category || '常用推荐',
                icon_text: wizard.icon_text || wizard.name.charAt(0).toUpperCase(),
                icon_color: wizard.icon_color,
                icon_url: wizard.icon_url,
                page: state.currentPage,
            });
            closeModal();
            state.shortcutCache = {};
            await loadShortcuts();
            toast('网站已添加', 'success');
        } catch(e) {
            showModalError('#wizErr', e.message);
            btn.disabled = false;
            btn.textContent = '＋ 添加网站';
        }
    };

    $('#wizUrl').focus();
}


export function showQuickAddModal(url, title) {
    if (gateGuest()) return; // 快速收藏属登录限定（2026-09-04 策略）
    openModal(`
        <div class="modal-title">⚡ 快速收藏</div>
        <div style="display:flex;align-items:center;gap:12px;padding:12px;background:rgba(91,141,212,0.06);border-radius:12px;margin-bottom:16px">
            <div id="qaIcon" style="width:48px;height:48px;border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:700;color:#fff;background:#5B8DD4;flex-shrink:0;overflow:hidden">
                ${(title || '?').charAt(0).toUpperCase()}
            </div>
            <div style="flex:1;min-width:0">
                <div id="qaName" style="font-size:14px;font-weight:600;color:var(--text);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(title || url)}</div>
                <div style="font-size:12px;color:var(--text-dim);overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(url)}</div>
            </div>
        </div>
        <div class="form-group" style="margin-bottom:12px">
            <label style="font-size:13px;color:var(--text-dim);margin-bottom:6px;display:block">网站名称</label>
            <input type="text" class="form-input" id="qaNameInput" value="${escAttr(title || '')}" placeholder="网站名称" maxlength="50" style="width:100%;padding:10px 14px;border-radius:10px">
        </div>
        <div class="form-group" style="margin-bottom:12px">
            <label style="font-size:13px;color:var(--text-dim);margin-bottom:6px;display:block">网站描述（可选）</label>
            <input type="text" class="form-input" id="qaDescInput" value="" placeholder="网站描述" maxlength="200" style="width:100%;padding:10px 14px;border-radius:10px">
        </div>
        <div id="qaLoading" style="display:none;text-align:center;padding:20px;font-size:13px;color:var(--text-dim)">
            正在获取网站信息…
        </div>
        <button class="btn btn-primary btn-block" id="qaConfirm" style="margin-top:8px">添加到导航页</button>
        <div style="text-align:center;margin-top:8px">
            <a href="javascript:void(0)" id="qaCancel" style="font-size:12.5px;color:var(--text-dim);text-decoration:none">取消</a>
        </div>
    `);

    let siteInfo = null;
    const nameInput = $('#qaNameInput');
    const descInput = $('#qaDescInput');
    const iconEl = $('#qaIcon');
    const confirmBtn = $('#qaConfirm');
    const loadingEl = $('#qaLoading');

    // 尝试获取网站信息
    loadingEl.style.display = 'block';
    confirmBtn.disabled = true;
    confirmBtn.textContent = '获取网站信息中…';

    apiGet(API.site_info + '?url=' + encodeURIComponent(url)).then(info => {
        siteInfo = info;
        if (info.title && nameInput && !nameInput.value) {
            nameInput.value = info.title.substring(0, 50);
            $('#qaName').textContent = info.title;
        }
        if (info.icon_text && iconEl) {
            iconEl.textContent = info.icon_text;
        }
        if (info.icon_color && iconEl) {
            iconEl.style.background = info.icon_color;
        }
        if (info.icon && iconEl) {
            const img = document.createElement('img');
            img.src = info.icon;
            img.style.cssText = 'width:60%;height:60%;object-fit:contain;opacity:0;transition:opacity 0.25s';
            img.referrerPolicy = 'no-referrer';
            img.onload = () => { iconEl.textContent = ''; img.style.opacity = '1'; iconEl.appendChild(img); };
        }
        if (info.description && descInput && !descInput.value) {
            descInput.value = info.description.substring(0, 200);
        }
    }).catch(() => {}).finally(() => {
        loadingEl.style.display = 'none';
        confirmBtn.disabled = false;
        confirmBtn.textContent = '添加到导航页';
    });

    $('#qaCancel').onclick = () => { closeModal(); history.replaceState({}, '', location.pathname); };

    confirmBtn.onclick = async () => {
        const name = nameInput.value.trim() || url;
        const desc = descInput.value.trim();
        confirmBtn.disabled = true;
        confirmBtn.textContent = '添加中…';
        try {
            await apiPost(API.shortcuts + '?action=create', {
                name: name.substring(0, 50),
                url: url,
                description: desc,
                icon_text: siteInfo?.icon_text || name.charAt(0).toUpperCase(),
                icon_color: siteInfo?.icon_color || '#5B8DD4',
                icon_url: siteInfo?.icon || '',
                icon_type: siteInfo?.icon ? 'url' : 'text',
                page: state.currentPage,
            });
            await loadShortcuts();
            closeModal();
            history.replaceState({}, '', location.pathname);
            toast('已收藏：' + name, 'success');
        } catch (e) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = '添加到导航页';
            toast('添加失败：' + e.message, 'error');
        }
    };

    if (nameInput) {
        nameInput.focus();
        nameInput.select();
        nameInput.onkeydown = (e) => { if (e.key === 'Enter') { e.preventDefault(); confirmBtn.click(); } };
    }
}

/* ==================== 首次访问引导 ==================== */

